import { getAvailableCarriers } from '@/api';
import { useSentryMutation } from '../utils/sentryQueryWrapper';
import {
  AvailableCarriersRequest,
  AvailableCarriersAdaptedResponse,
  ErrorMessageResponse,
} from '@/types';

// Get Available Carriers — new Phase 2 endpoint, returns adapted legacy shape.
// defaultErrorMessage: '' suppresses automatic toasts — all error handling is done
// via the onError callback at the call site (NoCarrierModal, etc.).
export const useGetAvailableCarriers = () => {
  return useSentryMutation<
    AvailableCarriersAdaptedResponse,
    ErrorMessageResponse,
    AvailableCarriersRequest
  >((request: AvailableCarriersRequest) => getAvailableCarriers(request), {
    defaultErrorMessage: '',
  });
};
